import { useAuthStore } from "../stores/auth-store";
import { useEffect } from "react";

export function useAuth() {
	const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
	const currentWorkspaceId = useAuthStore((state) => state.currentWorkspaceId);
	const user = useAuthStore((state) => state.user);
	const login = useAuthStore((state) => state.login);
	const logout = useAuthStore((state) => state.logout);
	const validateOtp = useAuthStore((state) => state.validateOtp);
	const getUserInfo = useAuthStore((state) => state.getUserInfo);
	const updateProfile = useAuthStore((state) => state.updateProfile);
	const setWorkspaceId = useAuthStore((state) => state.setWorkspaceId);

	// Centralized state from store (no more local state!)
	const loading = useAuthStore((state) => state.loading);
	const initialized = useAuthStore((state) => state.initialized);
	const isBrandAvailable = useAuthStore((state) => state.isBrandAvailable);
	const isNameAvailable = useAuthStore((state) => state.isNameAvailable);
	const verifyAuth = useAuthStore((state) => state.verifyAuth);

	// Trigger auth verification only once when the hook is first used
	// The store handles deduplication of concurrent calls
	useEffect(() => {
		if (!initialized) {
			verifyAuth();
		}
	}, [initialized, verifyAuth]);

	return {
		isAuthenticated,
		login,
		logout,
		validateOtp,
		getUserInfo,
		updateProfile,
		user,
		isBrandAvailable,
		isNameAvailable,
		loading,
		refresh: verifyAuth,
		currentWorkspaceId,
		setWorkspaceId,
	};
}
